module.exports = __webpack_public_path__ + "static/media/SWSCRC6-55.bd956d78.mp3";